import { Listbox, mediaMixin, spaceMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledConversationListNav = styled.nav`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden; // disable horizontal scrolling
  -webkit-overflow-scrolling: touch; // enable touch scrolling for Safari to fix scrollbar not showing up only when clicking

  // Setting overflow on the nav causes focus outline to become clipped
  // Added padding allows the outline to become visible
  ${mediaMixin(
    'xl',
    css`
      padding-left: 4px;
      padding-right: 4px;

      &:first-child {
        padding-top: 4px;
      }
    `,
  )}

  scrollbar-width: auto; // Firefox
  &::-webkit-scrollbar {
    width: 0px; // Set the width of the scrollbar for Safari and Chrome to 0 by default
  }

  &:hover::-webkit-scrollbar {
    width: 6px; // Set the width of the scrollbar for Safari and Chrome on hover
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${token('colors.gray300')}; /* Color of the scrollbar */
    border-radius: 3px; /* Rounded corners for the scrollbar */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${token('colors.gray500')}; /* Color of the scrollbar on hover */
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    width: 768px;
    margin: 0 auto;
  }

  @media screen and (min-width: 992px) and (max-width: 1023px) {
    width: 100%;
    margin: 0 auto;
  }
`;

export const StyledListbox = styled(Listbox)`
  max-height: fit-content;
  overflow-y: visible;
  border: none;

  &:focus {
    li[data-active='true'] {
      background-color: ${token('colors.gray100')} !important;
    }
  }

  // Since active and selected items have a background color,
  // Clipping the items when focus is enabled will prevent overlapping the focus outline
  ${mediaMixin(
    'xl',
    css`
      &:focus-visible {
        li {
          &:not(:first-child) {
            clip-path: inset(0px 4px 0px 4px);
          }

          &:first-child {
            clip-path: inset(4px 4px 0px 4px);
          }
        }

        li[aria-selected='true'] {
          &:not(:first-child) {
            clip-path: inset(0px 4px 0px 0px);
          }

          &:first-child {
            clip-path: inset(4px 4px 0px 0px);
          }
        }
      }
    `,
  )}
`;

export const StyledLoadMoreConversationsWrapper = styled.div`
  text-align: center;
  padding: ${spaceMixin('sm')} 0;
  border-top: 1px solid ${token('colors.gray300')};
  margin-top: -1px; // prevents the appearance of a double border
  margin-left: -4px;
  margin-right: -4px;
`;
